import { Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const StyledRewardPointCost = Text.withConfig<{ usePrimaryColor?: boolean }>(p => ({
  textTransform: 'capitalize',
  fontWeight: primitive.$fontWeightHeavy,
  ...(p.usePrimaryColor
    ? {
        color: primitive.$fieryRed,
      }
    : {}),
}));
